import { useEffect, useState } from "react";

export function useResponsiveVisibleCount(defaultCount: number = 3) {
  const [visibleCount, setVisibleCount] = useState(defaultCount);
  const widthRanges = [
    { maxWidth: 600, count: 1 },
    { maxWidth: 900, count: 1 },
    { maxWidth: 1200, count: 2 },
    { maxWidth: 1600, count: 3 },
    { maxWidth: 2000, count: 4 },
    { maxWidth: 2400, count: 6 },
    { maxWidth: Infinity, count: 7 }
  ];

  useEffect(() => {
    const updateVisibleCount = () => {
      const width = window.innerWidth;
      const range = widthRanges.find((range) => width < range.maxWidth);
      setVisibleCount(range ? range.count : defaultCount);
    };
    updateVisibleCount();
    window.addEventListener("resize", updateVisibleCount);
    return () => window.removeEventListener("resize", updateVisibleCount);
  }, []);

  return visibleCount;
}
